import React, {Component} from 'react';

import Button from 'base/components/Button';
import Toolbar from 'base/components/common/Toolbar';
import API, { AUTH_HEADER } from 'base/api'

const generujExcel = () => {
  fetch('https://rajd-app-v1-api.napwr.pl/api/student/export', {
    headers: new Headers(AUTH_HEADER)
  }).then(res => res.blob())
    .then(blob => {
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url;
      a.download = `bal-${new Date().toISOString()}.xlsx`;
      document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
      a.click();
      a.remove();  //afterwards we remove the element again
  });
}

const AdminIndex = () => (
  <div>
    <Toolbar title="Panel admina" titleUrl="/admin"/>
    <div className="container">
      <div className="admin-buttons-wrapper">
        <Button url="/admin/event">Zarządzaj wydarzeniem</Button>
        <Button url="/admin/list">Lista studentów</Button>
        <Button url="/admin/rooms">Pokoje</Button>
        <Button url="/admin/excel">Dodaj excela</Button>
        <Button onClick={generujExcel}>GENERUJ EXCELA</Button>
      </div>
    </div>
  </div>
);

export default AdminIndex;



// WEBPACK FOOTER //
// ./src/modules/Admin/views/AdminIndex.js